<template>
	<div>
		<div v-show="phone" class="ayo_about" @click="foothide()">
	    <div class="ayo_people_1">
	      <div class="ayo_icon">
	        <img src="../assets/ayo_icon.png" alt="">
	      </div>
	      <p v-if="lang"><span class="english">AYO! </span>音乐节</p>
	      <p v-else><span class="english">AYO! Music Festival</span></p>

        <!-- AYO！音乐节 6.3 回顾视频 Start-->
	      <div v-if="lang" class="ayo_video">
	        <div>
	          <embed src="https://imgcache.qq.com/tencentvideo_v1/playerv3/TPout.swf?max_age=86400&v=20161117&vid=n05183f2u46&auto=0" allowFullScreen="true" quality="high" width="646" height="393" align="middle" allowScriptAccess="always" type="application/x-shockwave-flash" flashskin="http://imgcache.qq.com/minivideo_v1/vd/res/skins/TencentPlayerMiniSkin.swf"></embed>
	        </div>
	      </div>
	      <div v-else="!lang" class="ayo_video">
	        <div><iframe width="646" height="393" src="https://www.youtube.com/embed/LsB70dm2Cmk" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen></iframe></div>
	      </div>
	      <p v-if="lang"><span class="english">2017.6.3 AYO!</span> 音乐节回顾</p>
	      <p v-else><span class="english">AYO! Music Festival I in June 3, 2017</span></p>
        <!-- AYO！音乐节 2017.6.3 回顾视频 End-->

        <!-- AYO！音乐节 2017.10.1-3 回顾视频 Start-->
	      <div v-if="lang" class="ayo_video">
	        <div>
	          <embed src="https://imgcache.qq.com/tencentvideo_v1/playerv3/TPout.swf?max_age=86400&v=20161117&vid=l0636yz5pje&auto=0" allowFullScreen="true" quality="high" width="646" height="393" align="middle" allowScriptAccess="always" type="application/x-shockwave-flash"></embed>
	        </div>
	      </div>
	      <div v-else="!lang" class="ayo_video">
	        <div><iframe width="646" height="393" src="https://www.youtube.com/embed/RThWS8MPaH8" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen></iframe></div>
	      </div>
	      <p v-if="lang"><span class="english">2017.10.1-3 AYO!</span> 音乐节回顾</p>
	      <p v-else><span class="english">AYO! Music Festival II in October 1st-3rd, 2017</span></p>
        <!-- AYO！音乐节 2017.10.1-3 回顾视频 End-->

        <!-- AYO！音乐节 2018.6.16-17 回顾视频 Start-->
        <div v-if="lang" class="ayo_video">
          <div>
            <embed src="https://imgcache.qq.com/tencentvideo_v1/playerv3/TPout.swf?max_age=86400&v=20161117&vid=n05183f2u46&auto=0" allowFullScreen="true" quality="high" width="646" height="393" align="middle" allowScriptAccess="always" type="application/x-shockwave-flash" flashskin="http://imgcache.qq.com/minivideo_v1/vd/res/skins/TencentPlayerMiniSkin.swf"></embed>
          </div>
        </div>
        <div v-else="!lang" class="ayo_video">
          <div><iframe width="646" height="393" src="https://www.youtube.com/embed/ZUw-g7OBNnk" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen></iframe></div>
        </div>
        <p v-if="lang"><span class="english">2018 AYO!</span> 音乐节苏州站回顾</p>
        <p v-else><span class="english">AYO! Music Festival 2018 Suzhou</span></p>
        <!-- AYO！音乐节 2018.6.16-17 回顾视频 End-->

	    </div>
	  	<div class="ayo_people">
	  		<p v-if="lang"><span class="english">AYO! </span>往期合作艺人</p>
	      <p v-else><span class="english">AYO! Cooperated artists</span></p>
	  		<div class="ayo_people_card">
  	        <img src="../assets/card/OG_Maco.jpg" alt="">
  	        <img src="../assets/card/Honey_Cocaine.jpg" alt="">
  	        <img class="" src="../assets/card/Soulja_Boy.jpg" alt="">
  	        <img src="../assets/card/Robb_Bank$.jpg" alt="">
  	        <img src="../assets/card/KOHH.jpg" alt="">
            <img src="../assets/card/dax.jpg" alt="">
            <img src="../assets/card/gai.jpg" alt="">
            <img src="../assets/card/Tizzy-T.jpg" alt="">
            <img src="../assets/card/Jony-J.jpg" alt="">
            <img src="../assets/card/Higher Brothers.jpg" alt="">
            <img src="../assets/card/OMENXIII.jpg" alt="">
  	        <img src="../assets/card/VAVA.jpg" alt="">
  	        <img src="../assets/card/Bridge.jpg" alt="">
  	        <img src="../assets/card/Afjn.jpg" alt="">
  	        <img src="../assets/card/Hx.jpg" alt="">
            <img src="../assets/card/MJ116.jpg" alt="">
            <img src="../assets/card/hhh.jpg" alt="">
            <img src="../assets/card/pg one.jpg" alt="">
  	        <img src="../assets/card/Hhhbb.jpg" alt="">
  	        <img src="../assets/card/C-Block.jpg" alt="">
  	        <img src="../assets/card/Msk.jpg" alt="">
  	        <img src="../assets/card/TY.jpg" alt="">
  	        <img src="../assets/card/Al_Rocco.jpg" alt="">
  	        <img src="../assets/card/Bbno$.jpg" alt="">
  	        <img src="../assets/card/Akj-akin.jpg" alt="">
            <img src="../assets/card/Fl-Pharaoh.jpg" alt="">
            <img src="../assets/card/yitai.jpg" alt="">
            <img src="../assets/card/Jellorio.jpg" alt="">
  	        <img src="../assets/card/buzzy.jpg" alt="">
            <img src="../assets/card/Guibian.jpg" alt="">
            <img src="../assets/card/pact.jpg" alt="">
            <img src="../assets/card/xinba.jpg" alt="">
  	        <img src="../assets/card/Fcyco.jpg" alt="">
  	        <img src="../assets/card/Yee.jpg" alt="">
            <img src="../assets/card/Sio.jpg" alt="">
  	        <img src="../assets/card/Yls.jpg" alt="">
  	        <img src="../assets/card/TOY.jpg" alt="">
  	        <img src="../assets/card/ONO.jpg" alt="">
  	        <img src="../assets/card/Dbz-Dabozz.jpg" alt="">
  	        <img src="../assets/card/WyPavel.jpg" alt="">
            <img src="../assets/card/sexy slippers.jpg" alt="">
  	        <img src="../assets/card/Young_Queenz.jpg" alt="">
  	        <img src="../assets/card/Htlq.jpg" alt="">
  	        <img src="../assets/card/LxnGali.jpg" alt="">
  	        <img src="../assets/card/Lil_Jet.jpg" alt="">
            <img src="../assets/card/xzz.jpg" alt="">
  	        <img src="../assets/card/Kozay.jpg" alt="">
  	        <img src="../assets/card/gali.jpg" alt="">
  	        <img src="../assets/card/Ha$.jpg" alt="">
  	        <img src="../assets/card/Zhb.jpg" alt="">
            <img src="../assets/card/Dx.jpg" alt="">
            <img src="../assets/card/kc.jpg" alt="">
            <img src="../assets/card/Fi9jiangche.jpg" alt="">
  	        <img src="../assets/card/Wsy.jpg" alt="">
  	        <img src="../assets/card/Jark_StickJcy.jpg" alt="">
            <img src="../assets/card/PRCbayinhan.jpg" alt="">
            <img src="../assets/card/young gee.jpg" alt="">
            <img src="../assets/card/cde.jpg" alt="">
            <img src="../assets/card/eTong.jpg" alt="">
            <img src="../assets/card/nine one.jpg" alt="">
            <img src="../assets/card/LAZY-AIR.jpg" alt="">
            <img src="../assets/card/doudou.jpg" alt="">
            <img src="../assets/card/Danengren.jpg" alt="">
            <img src="../assets/card/two-J.jpg" alt="">
            <img src="../assets/card/Wj.jpg" alt="">
            <img src="../assets/card/Dirty-Twinz.jpg" alt="">
            <img src="../assets/card/Big_Daddy.jpg" alt="">
	  		</div>
	  	</div>
	    <div id="ayo_people_2" class="ayo_people_2">
	      <div>
	        <img src="../assets/card_logo_1.png" alt="">
	      </div>
	      <div>
	        <p><span class="english">“YOUNG WILD FREE”</span></p>
	        <p v-if="lang">
	          <span class="english">AYO!</span>旗下打造的“<span class="english">AYO!</span>音乐节”是中国首个嘻哈音乐节，已成功举办2届，是目前国内最大型的嘻哈音乐节
	        </p>
	        <p v-else>
	          <span class="english">"AYO! Music Festival" is the first hip-hop music festival in China. It has been successfully held for 2 times. It is the largest hip-hop festival in China.</span>
	        </p>
	      </div>
	    </div>
	  	<div class="ayo_people_3">
	          <p v-if="lang">派嗨拜浪 ( 上海 ) 网络科技有限公司版权所有©2016【 沪ICP备16032276号 】</p>
	          <p v-else class="english">PAIHAIBAILANG (SHANGHAI) NETWORK TECHNOLOGY CO., LTD. All rights reserved©2016[Shanghai ICP no. 16032276]</p>
	          <p v-if="lang">本网站由派嗨拜浪 ( 上海 ) 网络科技有限公司提供</p>
	          <p v-else class="english">This website is provided by PAIHAIBAILANG (SHANGHAI) NETWORK TECHNOLOGY CO., LTD</p>
	  	</div>
	    <transition name="mybox">
	      <div  class="footer" v-show="fot_show"  @click.stop="footShow()">
	        <div><span v-if="lang">邮箱：</span><span v-else class="english">email: </span><span class="english">fxh@fangxuehai.cc</span></div>
	        <div>
	          <span v-if="lang">地址：上海市 杨浦区 军工路 100号 18栋 放学嗨</span>
	          <span v-else class="english">address: Afterschool, Building 18，No. 100, Jungong Road, Yangpu District, Shanghai</span>
	        </div>
	        <div v-on:click="link_to()" class="link_to">
	          <img src="../assets/sina_logo.png" alt="">
	          <span v-if="lang"> 放学嗨</span>
	          <span v-else class="english"> Afterschool</span>
	        </div>
	        <div>
	          <div>
	            <p><img src="../assets/wx_fxh.jpg" alt=""></p>
	            <p><img src="../assets/wx_logo.png" alt=""><span v-if="lang"> 放学嗨</span>
	          <span v-else class="english"> Afterschool</span></p>
	          </div>
	          <div>
	            <p><img src="../assets/wx_afsc.jpg" alt=""></p>
	            <p><img src="../assets/wx_logo.png" alt=""><span class="english"> AFSC</span></p>
	          </div>
	        </div>
	        <div class="ayo_people_3">
	          <p v-if="lang">派嗨拜浪 ( 上海 ) 网络科技有限公司版权所有©2016【 沪ICP备16032276号 】</p>
	          <p v-else class="english">PAIHAIBAILANG (SHANGHAI) NETWORK TECHNOLOGY CO., LTD. All rights reserved©2016[Shanghai ICP no. 16032276]</p>
	          <p v-if="lang">本网站由派嗨拜浪 ( 上海 ) 网络科技有限公司提供</p>
	          <p v-else class="english">This website is provided by PAIHAIBAILANG (SHANGHAI) NETWORK TECHNOLOGY CO., LTD</p>
	        </div>
	      </div>
	    </transition>
	    <div id="click_btn" @click.stop="footShow()" class="phone_us" :style="{border: '2px solid #' + bordercolor,backgroundColor: '#' + bgcolor,color: '#' + bordercolor}">
	      <span v-if="lang">联系我们</span>
	      <span v-else class="english">Contact us</span><span :style="{backgroundColor:'#'+bordercolor}"></span>
	    </div>
	  </div>
	  <div v-show="!phone" class="phone_ayo">
	  	<phone_ayo :lang="lang"></phone_ayo>
	  </div>
	</div>
  
</template>

<script>
import phone_ayo from './phone_AYO'

export default {
  name: 'AYOAbout',
  components: {
  	phone_ayo,
  },
  props:["lang"],
  data () {
    return {
      msg: '33',
      ost_top: '',
      person_top: '',
      bordercolor: 'FFFB00',
      bgcolor: '000000',
      fot_show: false,
      scrollTop: 0,
      flag: true,
      show: 'inline-block',
      show2: 'inline-block',
      phone: true
    }
  },
  methods: {
    handleScroll () {
      this.scrollTop = window.pageYOffset  //用于FF
            || document.documentElement.scrollTop
            || document.body.scrollTop
            || 0;
      this.ost_top = document.getElementById('click_btn').offsetTop + this.scrollTop;
      this.person_top = document.getElementById('ayo_people_2').offsetTop
      if ( this.flag == true  ) {
        if ( this.ost_top > this.person_top ) {
          this.bordercolor = '000000'
          this.bgcolor = 'FFFB00'
        }else {
          this.bordercolor = 'FFFB00'
          this.bgcolor = '000000'
        }
      }
    },
    footShow () {
      this.fot_show = !this.fot_show;;
      this.flag = false;
      if ( this.fot_show == false ) {
        if ( this.ost_top > this.person_top ) {
          this.bordercolor = '000000'
          this.bgcolor = 'FFFB00'
        }else {
          this.bordercolor = 'FFFB00'
          this.bgcolor = '000000'
          setTimeout(() => {
            this.bordercolor = 'FFFB00'
            this.bgcolor = '000000'
          },200);
        }
        this.flag = true;
      }else {
        setTimeout(() => {
          this.bordercolor = '000000'
          this.bgcolor = 'FFFB00'
        },200);
      }
    },
    foothide () {
      this.fot_show = false;
      this.flag = true;
      this.bordercolor = 'FFFB00'
      this.bgcolor = '000000'
      this.ost_top = document.getElementById('click_btn').offsetTop + this.scrollTop;
      this.person_top = document.getElementById('ayo_people_2').offsetTop
      if ( this.ost_top > this.person_top ) {
        this.bordercolor = '000000'
        this.bgcolor = 'FFFB00'
      }else {
        this.bordercolor = 'FFFB00'
        this.bgcolor = '000000'
        setTimeout(() => {
          this.bordercolor = 'FFFB00'
          this.bgcolor = '000000'
        },200);
      }
    },
    link_to () {
      window.location.href="https://weibo.com/u/5692890069?refer_flag=1001030101_&is_hot=1"
    },
    IsPC () {
      var userAgentInfo = navigator.userAgent;
      var Agents = ["Android", "iPhone",
        "SymbianOS", "Windows Phone", "iPod"];
      var flag = true;
      for (var v = 0; v < Agents.length; v++) {
        if (userAgentInfo.indexOf(Agents[v]) > 0) {
          flag = false;
          break;
        }
      }
      return flag;
    }
  },
  mounted () {
    this.phone = this.IsPC();

    if ( this.phone == true ) {
	    document.getElementById('ayo_icon').style.display = "none";
	    document.getElementById('ayo_icon_2').style.display = "inline-block";
	    document.getElementById('afsc_icon').style.display = "inline-block";
	    document.getElementById('afsc_icon_2').style.display = "none";
      this.ost_top = document.getElementById('click_btn').offsetTop;
      console.log(this.ost_top);
      window.addEventListener('scroll', this.handleScroll);

    }else {
      console.log(1111);
      console.log(2222);
    }

  },
  destroyed () {
    window.removeEventListener('scroll', this.handleScroll)
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>

	.ayo_about {
		background-color: #000000;
		min-width: 980px;
	}

  .ayo_people_1 {
    width: 100%;
    background-color: #000000;
    .ayo_icon {
      padding-top: 110px;
    }
    p {
      margin: 0;
      width: 100%;
      color: #FFFB00;
      padding-top: 25px;
      font-family: Heavy;
      font-size: 24px;
      text-align: center;
      margin-bottom: 50px;
      letter-spacing: 1px;
    }
    embed {

    }
    .ayo_video {
      position: relative;
      overflow: hidden;
      width: 100%;
      height: 413px;
      .ayo_btn {
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%,-50%);
        &:hover {
          cursor: pointer;
        }
      }
      .ayo_vio {
        position: absolute;
        width: 666px;
        left: 50%;
        top: 0;
        transform: translateX(-50%);
        height: 413px;
      }
      div {
        margin: 0 auto;
        border: 10px solid #FFFC01;
        width: 646px;
        height: 393px;
        overflow: hidden;
      }
    }
  }


	.ayo_people {
		background-color: #000000;
		p {
			margin: 0;
			width: 100%;
			color: #FFFB00;
			padding-top: 35px;
			font-family: Heavy;
			font-size: 24px;
      letter-spacing: 1px;
			text-align: center;
			margin-bottom: 50px;
      font-weight: bold;
		}
	}
	.ayo_people_card {
		width: 70%;
		margin: 0 auto;
		font-size: 0;
		text-align: center;
    padding-bottom: 60px;
		img {
      display: inline-block;
			vertical-align: top;
			width: 20%;
			margin-right: 20%/3;
			padding-bottom: 50px;
      transition: 0.5s all;
      &:hover {
        transform: scale(1.3);
      }
		}
		&>img:nth-child(4n) {
			margin-right: 0;
		}
		&>img:last-child {
			margin-right: 0;
		}
	}

  .ayo_people_2 {
    width: 100%;
    background-color: #FFFB00;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 150px 0 150px 0;
    &>div:nth-child(2) {
      margin-left: 50px;
      width: 300px;
      text-align: left;
      color: #000000;
      &>p:first-child {
        font-size: 28px;
        margin-bottom: 20px;
      }
      &>p:nth-child(n+2) {
        font-size: 14px;
        letter-spacing: 1px;
        text-align:justify;
        font-family: Regular;
      }
    }
  }

	.ayo_people_3 {
		width: 100%;
		background-color: #FFFB00;
		padding-bottom: 20px;
		p {
			margin: 0;
			width: 100%;
			color: #000000;
			font-family: Regular;
			font-size: 12px;
			text-align: center;
		}
	}
  .phone_us {
    position: fixed;
    bottom: 100px;
    left: 160px;
    text-align: left;
    width: 100px;
    padding-left: 3px;
    font-family: Regular;
    height: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    z-index: 100;
    &:hover {
      cursor: pointer;
    }
    span:nth-child(2) {
      display: inline-block;
      width: 3px;
      height: 3px;
      margin-left: 35px;
      margin-bottom: 1.5px;
      vertical-align: middle;
      border-radius: 50%;
    }
  }

  .footer {
    position: fixed;
    bottom: 0;
    width: 100%;
    height: 380px;
    background: #FFFB00;
    padding-top: 10px;
    p {
      margin: 0;
    }
    &>div:nth-child(-n+3) {
      color: #000000;
      margin-top: 20px;
      margin-bottom: 20px;
      height: 20px;
      line-height: 20px;
      font-family: Heavy;
    }
    &>div:nth-child(3) {
      span {
        display: inline-block;
        padding-top: 5px;
        vertical-align: top;
      }
    }
    &>div:nth-child(4) {
      display: flex;
      margin-top: 40px;
      margin-bottom: 40px;
      justify-content: center;
      &>div:first-child {
        margin-right: 80px;
      }
      span {
        color: #000000;
        display: inline-block;
        font-family: Heavy;
        vertical-align: top;
      }
    }
  }

  .mybox-leave-active,.mybox-enter-active{
      transition:  all 1s ease;
  }

  .mybox-leave-active,.mybox-enter{
      height:0px !important;
  }

  .mybox-leave,.mybox-enter-active {
      height: 380px;
  }
  
  .phone_ayo {
  	width: 100%;
  	overflow: hidden;
  }
</style>



// WEBPACK FOOTER //
// src/components/AYOAbout.vue